import React, { useState, useEffect, useRef } from "react";
import { Modal, Form, Input, Button, Select } from "antd";
import { BASE_URL, callApi } from "../../api/apiCaller";
import { GreenNotify, RedNotify } from "../../helper/helper";
import routes from "../../api/routes";
import configureAppStore from "../../redux/store";

const AddVideo = ({ visible, toggleModal, recordData }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [icon, setIcon] = useState(null);
  const [fileError, setFileError] = useState("");
  const fileInputRef = useRef(null);
  const [yogas, setYogas] = useState([]);
  const { Option } = Select;
  const dummyImage =
    "https://novathreadbucket.s3.amazonaws.com/nova-app-1685176470232-dummy.PNG";

  useEffect(() => {
    if (visible) {
      if (recordData) {
        console.log("record data??????????", recordData);
        form.setFieldsValue({
          title: recordData?.title,
          content: recordData?.content,
        });
        setIcon(recordData?.icon || dummyImage);
      } else {
        form.resetFields();
        setIcon(dummyImage);
      }
    }
  }, [visible, recordData, form]);

  useEffect(() => {
    if (visible) {
      callApi(
        "GET",
        `${routes.getYogas}`,
        null,
        setIsLoading,
        (res) => {
          if (res.status === 200) {
            setYogas(res?.data?.faceYogas);
          } else {
            RedNotify("Error Occurred. Please try again later.");
          }
        },
        (error) => {
          RedNotify(
            "An error occurred during the API call. Please try again later.",
            error
          );
        }
      );
    }
  }, [visible]);

  const pickImageFile = () => {
    fileInputRef.current.click();
  };

  const token = configureAppStore.getState().userDataSlice.token;
  const uploadImageOnS3 = async (file) => {
    console.log("file for uplod", file);
    const myHeaders = new Headers();
    const formData = new FormData();
    formData.append("file", file);
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };
    return await new Promise((resolve, reject) => {
      fetch(`${BASE_URL}uploadFile`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          console.log("result", result);
          resolve(result?.url);
        })
        .catch((error) => reject(error));
    });
  };

  const handleFileChange = async (event) => {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const file = fileList[0];

      const validTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!validTypes.includes(file.type)) {
        setFileError("Please select a valid image file (jpg, jpeg, png).");
        return;
      }
      try {
        const imgUrl = await uploadImageOnS3(file);
        setIcon(imgUrl);
        setFileError("");
      } catch (error) {
        setFileError("An error occurred while uploading the image.");
      }
    } else {
      setFileError("Please select a file.");
    }
  };

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("Values", values);
        const requestBody = {
          ...values,
          icon: icon,
        };
        console.log("Req body", requestBody);
        const getRes = (res) => {
          if (res.status === 200) {
            GreenNotify(
              recordData
                ? "Category Updated Successfully"
                : "Category Created Successfully"
            );
            toggleModal();
          } else {
            RedNotify("Error Occurred. Please try again later.");
          }
        };

        const apiCall = recordData
          ? callApi(
              "PATCH",
              `${routes.updateCategory}/${recordData._id}`,
              requestBody,
              setIsLoading,
              getRes
            )
          : callApi(
              "POST",
              `${routes.createCategory}`,
              requestBody,
              setIsLoading,
              getRes
            );

        apiCall.catch((error) => {
          RedNotify(
            "An error occurred during the API call. Please try again later.",
            error
          );
        });
      })
      .catch((errorInfo) => {
        console.error("Validation Error:", errorInfo);
      });
  };

  return (
    <Modal
      title={recordData ? "Update Category" : "Create Category"}
      visible={visible}
      onCancel={toggleModal}
      footer={[
        <Button key="cancel" onClick={toggleModal}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          {recordData ? "Update" : "Save"}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: "Please enter the title" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Content"
          name="content"
          rules={[{ required: true, message: "Please enter content" }]}
        >
          <Input.TextArea autoSize />
        </Form.Item>

        <div
          onClick={pickImageFile}
          style={{ marginBottom: "2rem" }}
          className="add-product-modal-input-title"
        >
          <h2>Icon</h2>
          <div className="add-product-modal-image">
            <img
              src={icon || dummyImage}
              alt="Highlight"
              style={{ width: "100px", height: "100px", margin: "0 5px" }}
            />
          </div>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
            required
          />
          {fileError && <p style={{ color: "red" }}>{fileError}</p>}
        </div>
      </Form>
    </Modal>
  );
};

export default AddVideo;
